import { v4 as uuid } from 'uuid';

import { IWsSessionEvent } from './types';
import { setWsRegistration } from '../../slices/sessionSlice';
import { setSocketStatusFailed, setSocketStatusSucceed } from '../../slices/socketStatusSlice';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { listenEventChannel } from '../socket';

/**
 * Регистрация сессии по WS
 */
export const registerWsSession =
  (startTime?: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry, custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents, eventChannel } = socket;

    const {
      session: { token },
    } = getState();

    if (!token) {
      return;
    }

    // uid события сессии
    const sessionUid = uuid();

    const wsSession: IWsSessionEvent = {
      sessionToken: token.sessionToken,
      type: EWsClientEventType.Session,
      uid: sessionUid,
      userId: token.userId,
    };

    clientEvents.set(wsSession.uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.Session,
    });

    try {
      await eventChannel.updateSession(wsSession);

      dispatch(setWsRegistration(sessionUid));

      dispatch(setSocketStatusSucceed());
      dispatch(listenEventChannel());
      telemetry.increment(ETelemetryEvents.ChatWsSessionSuccess);
      if (startTime) {
        const timeInMs = new Date().getTime() - startTime;

        telemetry.timing(ETelemetryEvents.ChatWsTokenConnectTime, timeInMs);
      }
    } catch (err) {
      dispatch(setSocketStatusFailed());
      logger.error('Не удалось зарегистрировать сессию по вебсокету', err);
      telemetry.increment(ETelemetryEvents.ChatWsSessionFail);

      clientEvents.set(wsSession.uid, {
        status: ERequestApiStatus.Failed,
        type: EWsClientEventType.Session,
      });
    }
  };
